import React from "react";
import {Checkbox, FormControlLabel, TextField} from "@mui/material";
import {forms, objects, strings} from "@atttomyx/shared-utils";

const WordForm = (props) => {
    const { data, onChange : onSync, allowAi } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.word) && modified.word.length >= 3 && modified.word.length <= 6
            && ((modified.ai && allowAi)
                || (strings.isNotBlank(modified.definition1)
                    && strings.isNotBlank(modified.sentence1) && strings.isNotBlank(modified.sentence2) && strings.isNotBlank(modified.sentence3)));

        onSync(modified);
    }

    return <div className="word-form">
        <div className="field">
            <TextField
                required={true}
                label="Word"
                type="text"
                value={forms.sanitizeValue(data.word)}
                error={strings.isNotBlank(data.word) && (data.word.length < 3 || data.word.length > 6)}
                onChange={(event) => onChange("word", event.target.value)}
            />
        </div>
        {allowAi ?
            <div className="option">
                <FormControlLabel
                    labelPlacement="end"
                    label="Generate info with AI"
                    control={<Checkbox
                        color="primary"
                        checked={forms.sanitizeOption(data.ai)}
                        onChange={(event) => onChange("ai", event.target.checked)}
                    />}
                />
            </div> : null}
        {!data.ai || !allowAi ? <>
            <div className="field">
                <TextField
                    required={true}
                    label="Definition 1"
                    type="text"
                    value={forms.sanitizeValue(data.definition1)}
                    onChange={(event) => onChange("definition1", event.target.value)}
                />
            </div>
            <div className="field">
                <TextField
                    label="Definition 2"
                    type="text"
                    value={forms.sanitizeValue(data.definition2)}
                    onChange={(event) => onChange("definition2", event.target.value)}
                />
            </div>
            <div className="field">
                <TextField
                    label="Definition 3"
                    type="text"
                    value={forms.sanitizeValue(data.definition3)}
                    onChange={(event) => onChange("definition3", event.target.value)}
                />
            </div>
            <div className="field">
                <TextField
                    required={true}
                    label="Sentence 1"
                    type="text"
                    value={forms.sanitizeValue(data.sentence1)}
                    onChange={(event) => onChange("sentence1", event.target.value)}
                />
            </div>
            <div className="field">
                <TextField
                    required={true}
                    label="Sentence 2"
                    type="text"
                    value={forms.sanitizeValue(data.sentence2)}
                    onChange={(event) => onChange("sentence2", event.target.value)}
                />
            </div>
            <div className="field">
                <TextField
                    required={true}
                    label="Sentence 3"
                    type="text"
                    value={forms.sanitizeValue(data.sentence3)}
                    onChange={(event) => onChange("sentence3", event.target.value)}
                />
            </div>
        </> : null}
    </div>
}

export default WordForm;
